import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Table, Toast } from 'react-bootstrap';
import { collection, query, where, getDocs, updateDoc, doc,addDoc ,getDoc,serverTimestamp} from 'firebase/firestore';
import { db } from '../FireBase';
import ToastAlert from '../components/ToastAlert';
import GenerateReceipt from '../components/GenerateReceipt';
import Loading from './Loading';
import Select from 'react-select';
import { Timestamp } from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";


const ManualPaymentModal = ({ show, onHide, schemeId, customers }) => {
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [payments, setPayments] = useState([]);
    const [Quantity,setQuantity]= useState('');
    const [loading, setLoading] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('success');
    const [transactionData, setTransactionData] = useState(null);
    const [scheme,setScheme]= useState('');
    const [paymentDates, setPaymentDates] = useState({});
    const [paymentMethods, setPaymentMethods] = useState({});
    const [selectedSubscriptionId, setSelectedSubscriptionId] = useState(null);



    // console.log(show, onHide, schemeId, customers)
    useEffect(() => {
        if (selectedCustomer && selectedSubscriptionId) {
            fetchPayments(selectedCustomer);
            
        }
        if(schemeId){
            fetchSchemeDetails(schemeId);
        }
      
    }, [selectedCustomer,schemeId,selectedSubscriptionId]);
    const fetchSchemeDetails = async () => {
        try {
          const docRef = doc(db, 'schemes', schemeId);
          const docSnap = await getDoc(docRef);
  
          if (docSnap.exists()) {
            const schemeData = { schemeId: docSnap.id, ...docSnap.data() };
            setScheme(schemeData);
            // console.log(schemeData)
          } else {
            console.error('No such scheme document!');
          }
        } catch (error) {
          console.error('Error fetching scheme details:', error);
        } finally {
          setLoading(false);
        }
      };
  const fetchPayments = async (cusmid) => {
    try {
        setLoading(true);

        // Step 1: Fetch subscriptions for this customer and scheme
        const subscriptionsQuery = query(
            collection(db, 'subscriptions'),
            where('userId', '==', cusmid),
            where('schemeId', '==', schemeId),
            where('subscriptionId', '==', selectedSubscriptionId)
        );
        const subscriptionsSnapshot = await getDocs(subscriptionsQuery);

        if (!subscriptionsSnapshot.empty) {
            // Step 2: Filter subscriptions (exclude discontinued)
            const validSubscriptions = subscriptionsSnapshot.docs.filter(doc => {
                const data = doc.data();
                return !data.status || data.status !== 'discontinued';
            });

            if (validSubscriptions.length > 0) {
                const subscriptionDoc = validSubscriptions[0]; // take first valid
                const subscriptionData = subscriptionDoc.data();

                const totalMonths = subscriptionData.totalMonths;
                const purchasedQuantity = subscriptionData.quantity;

                // Step 3: Payments (fallback to pending list if missing)
                const payments = subscriptionData.payments || 
                    Array.from({ length: totalMonths }, (_, i) => ({
                        month: i + 1,
                        paymentStatus: 'Pending'
                    }));

                setPayments(payments);
                setQuantity(purchasedQuantity);
            } else {
                console.error('All subscriptions are discontinued for customer ID:', cusmid);
            }
        } else {
            console.error('No subscription found for customer ID:', cusmid);
        }
    } catch (error) {
        console.error('Error fetching payments:', error);
    } finally {
        setLoading(false);
    }
};

const handlePaymentMethodChange = (month, method) => {
  setPaymentMethods((prev) => ({ ...prev, [month]: method }));
};

    const handlePaymentStatusChange = async (month, status,date,paymentMethod) => {
        try {
            setLoading(true);
            const subscriptionsQuery = query(
                collection(db, 'subscriptions'),
                where('userId', '==', selectedCustomer),
                where('schemeId', '==', schemeId),
                where('subscriptionId', '==', selectedSubscriptionId)
            );
            const subscriptionsSnapshot = await getDocs(subscriptionsQuery);

            if (!subscriptionsSnapshot.empty) {
                const subscriptionDoc = subscriptionsSnapshot.docs[0];
                const customerRef = doc(db, 'subscriptions', subscriptionDoc.id);
                const subscriptionData = subscriptionDoc.data();
                const updatedPaidMonths = subscriptionData.paidMonths + 1;
                const matchedPayment = subscriptionData.payments.find(p => p.month === month);
                const monthName = matchedPayment?.monthName ; // fallback if monthName not stored
                const year = matchedPayment?.year ;
                const subId= subscriptionData.subscriptionId;

                const updatedPayments = subscriptionData.payments.map(payment =>
                    payment.month === month ? { ...payment, paymentStatus: status,paidTimestamp:new Date().toISOString() } : payment
                );
                await updateDoc(customerRef, { payments: updatedPayments,paidMonths:updatedPaidMonths ,});

                setPayments(updatedPayments);
                setToastMessage("Manaual entry updated. please wait for the recipt to be generated.  Scroll down for the recipt.");
                setToastVariant('success');
                setShowToast(true);

                if (status === 'Paid') {
                    const amount = subscriptionData.monthlyPayment; // Assuming pricePerMonth is stored in subscriptionData
                    console.log(amount)
                       const transactionId = `TXN-${uuidv4().replace(/-/g, "").slice(0, 12).toUpperCase()}`;
                        const transactionRef = collection(db, 'transactions');
                        const newTransaction = {
                            transactionId,
                            schemename: scheme.name,
                            totalpaid:updatedPaidMonths,
                            overallmonths:subscriptionData.totalMonths,
                            Quantity:subscriptionData.quantity,
                            schemeId:schemeId,
                            userId: selectedCustomer,
                            status:'Paid',
                            month: month,
                            paymentAmount: amount,
                           paymentDate: Timestamp.fromDate(new Date(date)),

                            
                            paymentType: 'Manual Payment',
                            paidFor:` ${monthName} - ${year}`,
                            ModeOfPayment: paymentMethod, // ✅ Use selected method
                            subscriptionId:subId,
                            paidAt: serverTimestamp(),
                        
                        };
                         console.log(transactionData)
                        setTransactionData(newTransaction);
                        await addDoc(transactionRef, newTransaction);
                        <GenerateReceipt transaction={transactionData} />
                       
                    // await createTransaction(selectedCustomer, month, amount);
                    
                }
            } else {
                console.error('No subscription found for customer ID:', selectedCustomer);
            }
            setLoading(false);
        } catch (error) {
            console.error('Error updating payment status:', error);
            setLoading(false);
        }
    };
    // const createTransaction = async (cusmid, month, amount) => {
    //     try {
         
           
    //         return newTransaction;
    //     } catch (error) {
    //         console.error('Error creating transaction:', error);
    //     }
    // };

   const closemodal =()=>{
        setPayments('');
        setSelectedCustomer('');
        onHide();
        setTransactionData('');
        setPaymentDates('');
        setQuantity('');
   }
   const handleDateChange = (month, date) => {
    setPaymentDates((prev) => ({
      ...prev,
      [month]: date
    }));
  };
  
   if(loading){
          <Loading/>  
   }
   const customerOptions = customers.map((customer) => ({
    value: customer.subscriptionId,
    customerId: customer.cusmid,
    label: `${customer.name} - ${customer.phone} - ${customer?.address?.area ? customer?.address?.area : 'N/A'} - QTY:${customer.quantity}`,
    subscriptionId: customer.subscriptionId || null,
  }));

    return (
        
        <>
       
         <ToastAlert
                show={showToast}
                setShow={setShowToast}
                message={toastMessage}
                variant={toastVariant}
            />
        <Modal show={show} onHide={closemodal} size='lg'>
            <Modal.Header closeButton>
                <Modal.Title>Manual Payment Entry - {scheme.schemeId}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h4>{scheme.name}
                </h4>
                <br/>
                <Form>
                    <Form.Group controlId="customerSelect">
                        <Form.Label>Select Customer</Form.Label>
                        <Select
                            options={customerOptions}
                            onChange={(selectedOption) => {
                                setSelectedCustomer(selectedOption?.customerId || "");
                                setSelectedSubscriptionId(selectedOption?.subscriptionId || null);
                            }}

                            placeholder="Select a customer"
                            isClearable
                            />
                                                </Form.Group>
                                                <br/>
                        <h5>Purchased quantity: {Quantity? Quantity : 'N/A'}</h5>
                    {payments.length > 0 && (
                        <Form.Group controlId="payments">
                            <Form.Label>Payments</Form.Label>
                            <Table striped hover responsive>
                                <thead>
                                    <tr>
                                        <th>Month</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {payments.map((payment, index) => (
                                        <tr key={index}>
                                            <td>{payment.month}</td>
                                            <td>{payment.paymentStatus}</td>
                                            <td>
                                                {/* {payment.paymentStatus === 'Pending' ? (
                                                    <Button variant="outline-success" className="btn" onClick={() => handlePaymentStatusChange(payment.month, 'Paid')}>
                                                        Mark as Paid
                                                    </Button>
                                                ) : (
                                                    <Button variant="outline-danger" className="btn" onClick={() => handlePaymentStatusChange(payment.month, 'Pending')}>
                                                        Mark as Unpaid
                                                    </Button>
                                                )} */}
                                           {payment.paymentStatus === 'Pending' && (
                                                <div className="d-flex align-items-center gap-2">
                                                    <input
                                                    type="date"
                                                    value={paymentDates[payment.month] || ""}
                                                    onChange={(e) => handleDateChange(payment.month, e.target.value)}
                                                    className="form-control"
                                                    style={{ maxWidth: "180px" }}
                                                    />
                                                      <div className="d-flex align-items-center gap-2">
                                                        {["Cash", "Razorpay"].map((method) => (
                                                        <Form.Check
                                                            key={method}
                                                            type="radio"
                                                            label={method}
                                                            name={`paymentMethod-${payment.month}`} // ✅ unique name per row
                                                            value={method}
                                                            checked={paymentMethods[payment.month] === method}
                                                            onChange={(e) => handlePaymentMethodChange(payment.month, e.target.value)}
                                                        />
                                                        ))}
                                                    </div>
                                                    <Button
                                                    variant="outline-success"
                                                    disabled={!paymentDates[payment.month]} // ✅ Disable until date is picked
                                                    onClick={() => {
                                                        const confirmChange = window.confirm(
                                                        `Are you sure you want to mark Month ${payment.month} as Paid on ${paymentDates[payment.month]}?`
                                                        );
                                                        if (confirmChange) {
                                                        handlePaymentStatusChange(payment.month, 'Paid', paymentDates[payment.month], paymentMethods[payment.month]);
                                                        }
                                                    }}
                                                    >
                                                    Mark as Paid
                                                    </Button>
                                                </div>
                                                )}

                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Form.Group>
                    )}
                </Form>
            </Modal.Body>
            {transactionData &&(
                <GenerateReceipt transaction={transactionData} />
            )}
        </Modal>
        </>
    );
};

export default ManualPaymentModal;